// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"564f26db","274":"2f86fa1d","404":"9aa26ef8","511":"d784e567","558":"f7757086","643":"ed4bdb5c","650":"f8b5ba42","944":"8eeb880a"}[chunkId] + ".chunk.js";
};